module.exports = __webpack_public_path__ + "static/media/product_item_fishing_net_lines.1896a226.jpg";